import React, { createContext, useState, useContext, useCallback } from "react";

import PropTypes from "prop-types";

const initialState = {
  searchWidgetIntersectRatio: 1,
};

/*
 Context to share scroll related values
*/
export const ScrollContext = createContext({
  ...initialState,
  setSearchWidgetIntersectRatio: () => {},
});
ScrollContext.displayName = "ScrollContext";

/*
 Component encapsulating app related state and declaring provision via the
 React context api. Can be imported and rendered in a parent component that
 have multiple children needing access to the same app state, but the
 preferred usage is to wrap the parent component with the HOC declared below.
*/
function ScrollContextProvider({ children }) {
  const [state, setState] = useState(initialState);

  const setSearchWidgetIntersectRatio = useCallback(ratio => {
    setState(prevState => ({
      ...prevState,
      searchWidgetIntersectRatio: ratio,
    }));
  }, []);

  return (
    <ScrollContext.Provider
      value={{
        ...state,
        setSearchWidgetIntersectRatio,
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
}

ScrollContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

/*
 HOC to provision ScrollContextProvider ßwraps a parent component that have child nodes
 that need to share / access the same search related state
 - usage: withScrollContext(Component)
*/
// eslint-disable-next-line react/display-name
export const withScrollContext = WrappedComponent => props => {
  return (
    <ScrollContextProvider>
      <WrappedComponent {...props} />
    </ScrollContextProvider>
  );
};

export const useScrollContext = () => useContext(ScrollContext);
